module.exports = __webpack_public_path__ + "media/thumbnails/body-style-1-6c8b63b2.svg";